<app-loader *ngIf="isDisabled"></app-loader>
<div class="container">
    <!-- Header -->
    <div class="header">
        <h4><i class="bi bi-people-fill"></i> Employees in Device</h4>
        <div class="header-actions">
            <ng-select name="DeviceSerialNo" [items]="DeviceData" bindLabel="serial_num" bindValue="serial_num"
                [(ngModel)]="this.Devicefilter.requestBody.DeviceSerialNo" placeholder="DeviceSerial No"
                [clearable]="false" (change)="Clear();GetDeviceDetail()">
            </ng-select>
            <button type="button" class="export-btn" (click)="ESS_SiteWiseDeviceDetailsSelect()">
                <i class="bi bi-check2"></i> Apply
            </button>
            <button type="button" class="export-btn" (click)="ESS_SiteWiseDeviceDetailsSelect(true)">
                <i class="bi bi-file-earmark-arrow-down"></i> Export Report
            </button>
        </div>
    </div>
    <div class="summary-section">
        <div class="summary-card total-punches" [ngClass]="{'filter-select':FilterIndex == 1}"
            (click)="FilterData(1); $event.stopPropagation()">
            <div class="card-header">
                <div class="card-title">Total Employees</div>
                <div class="card-icon">
                    <i class="fas bi-people-fill"></i>
                </div>
            </div>
            <div class="card-value">{{this.Card.Total}}</div>
            <div class="punch-breakdown">
                <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 1.1}"
                    (click)="FilterData(1.1); $event.stopPropagation()">
                    <div class="breakdown-label color-in">
                        <i class="bi bi-person-fill"></i>
                        <span style="width:175px">Admin</span>
                    </div>
                    <div class="breakdown-value color-in">{{this.Card.Admin}}</div>
                </div>

                <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 1.2}"
                    (click)="FilterData(1.2); $event.stopPropagation()">
                    <div class="breakdown-label color-out">
                        <i class="bi bi-person-fill"></i>
                        <span style="width:175px">User</span>
                    </div>
                    <div class="breakdown-value color-out">{{this.Card.User}}</div>
                </div>
            </div>
        </div>

        <div class="summary-card sync-rate">
            <div class="card-header">
                <div class="card-title">Pending Image Sync</div>
                <div class="card-icon">
                    <i class="bi-arrow-repeat"></i>
                </div>
            </div>
            <div class="card-value">{{this.Card.ImageUnSync}}
                <div class="punch-breakdown">
                    <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 2.1}"
                        (click)="FilterData(2.1); $event.stopPropagation()">
                        <div class="breakdown-label color-in">
                            <i class="bi bi-file-earmark-image"></i>
                            <span style="width:175px">Sync</span>
                        </div>
                        <div class="breakdown-value color-in">{{this.Card.ImageSync}}</div>
                        <div class="breakdown-percentage">{{this.Card.ImageSyncRate}}%</div>
                    </div>

                    <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 2.2}"
                        (click)="FilterData(2.2); $event.stopPropagation()">
                        <div class="breakdown-label color-sync">
                            <i class="bi bi-image-alt"></i>
                            <span style="width:175px">Unsync</span>
                        </div>
                        <div class="breakdown-value color-out">{{this.Card.ImageUnSync}}</div>
                        <div class="breakdown-percentage">{{this.Card.ImageUnSyncRate}}%</div>
                    </div>

                    <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 2.3}"
                        (click)="FilterData(2.3); $event.stopPropagation()">
                        <div class="breakdown-label color-out">
                            <i class="bi bi-file-earmark-x"></i>
                            <span style="width:175px">Not Applicable</span>
                        </div>
                        <div class="breakdown-value color-out">{{this.Card.NotApplicable}}</div>
                        <div class="breakdown-percentage">{{this.Card.NotApplicableRate}}%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-content">
        <div class="content-header">
            <h2>Employee List {{this.Devicefilter.requestBody.DeviceSerialNo}}</h2>
        </div>
        <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th scope="col">
                        <div style="width:5px"><input class="form-check-input" type="checkbox" id="IsCheckAll"
                                name="IsCheckAll" (click)="ARCheck($event,0,true)">
                        </div>
                    </th>
                    <th style="width: 200px;">Employee Detail</th>
                    <th>Device Serial No</th>
                    <th style="width: 150px;">BSCode</th>
                    <th style="width: 150px;">CompanyCode</th>
                    <th>Image Sync</th>
                    <th style="width: 100px;">EnrollID</th>
                    <th style="width: 100px;">UserType</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Data; let i = index">
                    <th scope="row" style="width: 5px;">{{ i + 1 }}</th>
                    <td class="text-center">
                        <div style="width: 5px;"><input class="form-check-input" type="checkbox" id="IsCheck{{i}}"
                                name="IsCheck{{i}}" (click)="ARCheck($event,i)" [(ngModel)]="element['IsCheck']">
                        </div>
                    </td>
                    <td style="width: 300px;">
                        <div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="element['ImagePath'] != null && element['ImagePath'] != ''"
                                    (click)="common.FullImage('',{ProfileImage:element['ImagePath'],Name:element['EmpName'],Code:element['EmpCode']} )"
                                    mat-card-image class="userImage" [src]="element['ImagePath']" />

                                <img *ngIf="(element['ImagePath'] == null || element['ImagePath'] == '') && (element['Base64'] != null && element['Base64'] != '')"
                                    (click)="common.FullImage('',{ProfileImage:'data:image/jpeg;base64,'+element['Base64'],Name:element['EmpName'],Code:element['EmpCode']} )"
                                    mat-card-image class="userImage"
                                    [src]="'data:image/jpeg;base64,'+element['Base64']" />
                            </div>
                            <div class="col-auto">
                                <span class="text-label">{{element['EmpName']}}</span><br />
                                <span class="text-label-light">#{{element['EmpCode']}}</span><br />
                            </div>
                        </div>
                    </td>
                    <td> {{element['DeviceSerialNo']}}</td>
                    <td style="width: 150px;"> {{element['BSCode']}}</td>
                    <td style="width: 150px;"> {{element['CompanyCode']}}</td>
                    <td style="text-align-last:center"> <span class="badge"
                            [ngClass]="{'view':element['IsImageSync'] == null,'warning':!element['IsImageSync'],'success':element['IsImageSync']}">
                            {{element['IsImageSync'] == null?'Not Applicable':element['IsImageSync']?'Yes':'No'}}</span>
                    </td>
                    <td style="width: 100px;" class="text-end">{{element['EnrollID']}}</td>
                    <td style="text-align-last:center"> <span class="badge"
                            [ngClass]="{'view':element['RollID'] == 1,'success':element['RollID'] == 0}">
                            {{element['RollID'] == 1?'ADMIN':'USER'}}</span>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="m-2">
            <div class="row">
                <div class="col-md-3">
                    <label for="DropUserType" class="form-font-label">User Type</label>
                    <select class="form-select" aria-label="DropUserType" placeholder="UserType" title="UserType"
                        name="DropUserType" data-live-search="true" [(ngModel)]="UserType" #DropUserType="ngModel">
                        <option disabled hidden [value]=null>--User Type--</option>
                        <option [value]=1>Admin</option>
                        <option [value]=0>User</option>
                    </select>
                </div>
                <div class="col-md-2 pt-4">
                    <button type="button" class="btn btn-primary" [disabled]="isDisabled" (click)="updateUserType()"><i
                            class="bi bi-pass" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Update':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-action-bar">
        <div class="device-info-card"
            [ngClass]="{'device-info-card-on':this.DeviceInfoCard.status == 1,'device-info-card-off':this.DeviceInfoCard.status == 0}"
            style="width:max-content">
            <div class="device-icon">
                <i class="bi bi-person-bounding-box"></i>
            </div>
            <div class="device-details">
                <h3>{{this.DeviceInfoCard.DeviceSerialNo}} | <i class="bi"
                        [ngClass]="{'bi-wifi':this.DeviceInfoCard.status == 1,'bi-wifi-off':this.DeviceInfoCard.status == 0}"></i>
                    {{this.DeviceInfoCard.status == 0 ?'Offline':'Online'}}</h3>
            </div>
        </div>
        <div class="cancel-back-buttons">
            <button type="button" class="back-btn-bottom" id="backBtn" [routerLink]="['/attendancedevice/device']">
                <i class="fas bi bi-arrow-left"></i>
                Back
            </button>
        </div>
    </div>
</div>